module.exports = __webpack_public_path__ + "static/media/Teeth_alignment_modelling_ace.f9e8f8d3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgicons/Teeth_alignment_modelling_ace.svg
// module id = 941
// module chunks = 0